

















import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '@/tasks/mixins/dynamic-question';
import AiLoadingOverlay from '@/tasks/components/AiLoadingOverlay.vue';

export default {
  name: 'OleMissL4PostLabPart4',
  components: {AiLoadingOverlay, STextarea},
  mixins: [DynamicQuestionMixin()],
  props: {
    isSubmitting: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      inputs: {
        part4_4: null,
      },
      questions: [
        {
          text: 'What measurements would you need from Mr. Humphrey in order to help with the problem of identifying the piece?',
          inputName: 'part4_4',
        },
      ],
    };
  },
};
